import React, {FC} from 'react';
import {connect} from 'react-redux';

import {useInitialEffect} from '../../../../libs/shared/core/src/helpers/react/hooks/useEffectHelpers';
import {ResolveStateProps} from '../../../../libs/shared/core/src/store/helpers/commonReselectHelpers';
import {ResolveDispatchProps} from '../../../../libs/shared/core/src/store/helpers/reduxHelpers';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {VisualContactModel} from '../../../models/api/visualContactModel';
import {AppState} from '../../../store/appState';
import {fetchAccountAsyncAction} from '../../../store/data/accounts/accountsActions';
import {makeGetAccount} from '../../../store/data/accounts/accountsSelectors';
import {ContactPluginHeaderContact} from './contactPluginHeaderContact';

/*
 * Props.
 */

interface ContactPluginHeaderContactContainerPublicProps {
  isSelected: boolean;
  isTeammate?: boolean;
  contact: VisualContactModel;
  onSelectedContactChange: (model: VisualContactModel) => void;
}

type ContactPluginHeaderContactContainerStateProps = ResolveStateProps<typeof mapStateToProps>;
type ContactPluginHeaderContactContainerDispatchProps = ResolveDispatchProps<typeof mapDispatchToProps>;
type ContactPluginHeaderContactContainerProps = ContactPluginHeaderContactContainerPublicProps &
  ContactPluginHeaderContactContainerDispatchProps &
  ContactPluginHeaderContactContainerStateProps;

/*
 * Selectors.
 */

function getAccountId(_state: AppState, props: ContactPluginHeaderContactContainerPublicProps) {
  return props.contact.card?.accountId;
}

/*
 * Component.
 */

export const ContactPluginHeaderContactContainerComponent: FC<ContactPluginHeaderContactContainerProps> = (
  props,
) => {
  const {isSelected, contact, account, isTeammate, onSelectedContactChange, fetchAccountAsync} = props;

  // Check if we need to fetch the account
  useInitialEffect(() => {
    if (account || !contact.card?.accountId) {
      return;
    }
    fetchAccountAsync(contact.card.accountId);
  });

  return (
    <ContactPluginHeaderContact
      isSelected={isSelected}
      contact={contact}
      account={account || undefined}
      isTeammate={isTeammate}
      onSelectedContactChange={onSelectedContactChange}
    />
  );
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  account: makeGetAccount(getAccountId),
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  fetchAccountAsync: fetchAccountAsyncAction,
}));

export const ContactPluginHeaderContactContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactPluginHeaderContactContainerComponent);
